"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Customer_1 = require("../domain/Customer");
const FormData = require('form-data');
class CustomerRepositoryImpl {
    fetcherAmplify;
    fetcherAxios;
    constructor(fetcherAmplify, fetcherAxios) {
        this.fetcherAmplify = fetcherAmplify;
        this.fetcherAxios = fetcherAxios;
    }
    async saveFile(url, fields, file) {
        const formData = new FormData();
        const keys = [
            'Content-Type',
            'key',
            'bucket',
            'X-Amz-Algorithm',
            'X-Amz-Credential',
            'X-Amz-Date',
            'X-Amz-Security-Token',
            'Policy',
            'X-Amz-Signature',
        ];
        keys.forEach((name) => {
            formData.append(name, fields[name]);
        });
        formData.append('file', file);
        return this.fetcherAxios.post(url, formData);
    }
    async getCustomer(id, querys) {
        const customer = await this.fetcherAmplify.get(`/v1/customers/${id}`, {
            ...(querys && {
                queryStringParameters: querys,
            }),
        });
        return customer;
    }
    async updateCustomer(customer, attachments) {
        const { id, ...body } = customer;
        const response = await this.fetcherAmplify.put(`/v1/customers/${id}`, {
            body,
            queryStringParameters: {
                customerType: customer.type,
            },
        });
        if (customer.type === Customer_1.CustomerType.BUSINESS) {
            const filesToUpload = attachments
                ? Object.entries(attachments).map(([fileName, file]) => {
                    if (fileName in response.attachments &&
                        file &&
                        fileName in attachments) {
                        const { url, fields } = response.attachments?.[fileName].upload;
                        return () => this.saveFile(url, fields, file);
                    }
                })
                : [];
            await Promise.all(filesToUpload.map((f) => f?.()));
        }
    }
    async createOtp(customer, type) {
        const response = await this.fetcherAmplify.post(`/v1/customers/${customer.id}/otp`, {
            queryStringParameters: {
                customerType: customer.type,
            },
            body: {
                type,
            },
        });
        return response;
    }
    async verifyOtp(customer, otpId, code) {
        await this.fetcherAmplify.put(`/v1/customers/${customer.id}/otp/${otpId}`, {
            queryStringParameters: {
                customerType: customer.type,
            },
            body: {
                code,
            },
        });
    }
}
exports.default = CustomerRepositoryImpl;
//# sourceMappingURL=CustomerRepositoryImpl.js.map